module.exports = __webpack_public_path__ + "img/info-card-green-icon.7ae10277.svg";